<template>
  <div class="data-page">
    <el-row :gutter="20" type="flex" justify="end">
      <el-col :xl="18" :lg="16" style="display:flex;align-items:center;">
        <label style="width:70px;">{{ $t('performance-analysis::shopName') }}</label>
        <el-select
          v-model="selectedShop"
          :popperAppendToBody="false"
          :placeholder="$t('system::common::select_placeholder')"
          @change="changeShop"
        >
          <el-option
            v-for="item in shopList"
            :key="item.shopId"
            :label="item.shopName"
            :value="item.shopId"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :xl="6" :lg="8" style="display:flex;align-items:center;">
        <label style="width:150px;">{{ $t('performance-analysis::orderDate') }}</label>
        <el-date-picker
          style="width: 100%"
          :appendToBody="false"
          :clearable="false"
          @change="handlerDateChange"
          v-model="date"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </el-col>
      <el-button style="margin-right: 10px;" @click="$router.push({ path: reportJumpUrl().performAnalysis })">
        {{ $t('system::common::btn::check_report') }}
      </el-button>
    </el-row>

    <el-row :gutter="20" class="card-content">
      <el-col :lg="6" :md="6" :sm="6" :xl="6" v-for="(item, index) in cardOptions" :key="index" class="card-item">
        <dataCard :option="item" v-loading="loading.card"></dataCard>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :lg="24" :md="24" :sm="24" :xl="24">
        <reportCard
          :config="delieveredLineCharts"
          v-loading="loading.delieveredLineCharts"
          :style="`height: ${reportHeight};`"
        ></reportCard>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :lg="24" :md="24" :sm="24" :xl="24">
        <reportTable :config="shippingTable" v-loading="loading.shipping" :style="`height: ${reportHeight};`">
          <el-table-column
            prop="shopName"
            :label="$t('performance-analysis::send::table_shopName')"
            min-width="130px"
            showOverflowTooltip
          ></el-table-column>
          <el-table-column
            prop="orderNum"
            :label="$t('performance-analysis::send::table_order')"
            min-width="150px"
          ></el-table-column>
          <el-table-column
            prop="unshippingOrderNum"
            :label="$t('performance-analysis::send::table_notSend')"
            min-width="180px"
          ></el-table-column>
          <el-table-column
            prop="05DayShippingOrderNum"
            :label="$t('performance-analysis::send::table_fiveSendOrder')"
            min-width="180px"
          ></el-table-column>
          <el-table-column
            prop="05DayShippingRate"
            :label="$t('performance-analysis::send::table_fiveSendRate')"
            min-width="150px"
          >
            <template slot-scope="scope">
              <span>{{ scope.row['05DayShippingRate'] }}%</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="1015DayShippingOrderNum"
            :label="$t('performance-analysis::send::table_tenSendOrder')"
            min-width="180px"
          ></el-table-column>
          <el-table-column
            prop="1015DayShippingRate"
            :label="$t('performance-analysis::send::table_tenSendRate')"
            min-width="150px"
          >
            <template slot-scope="scope">
              <span>{{ scope.row['1015DayShippingRate'] }}%</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="15DayShippingOrderNum"
            :label="$t('performance-analysis::send::table_fifteenSendOrder')"
            min-width="180px"
          ></el-table-column>
          <el-table-column
            prop="15DayShippingRate"
            :label="$t('performance-analysis::send::table_fifteenSendRate')"
            min-width="150px"
          >
            <template slot-scope="scope">
              <span>{{ scope.row['15DayShippingRate'] }}%</span>
            </template>
          </el-table-column>
        </reportTable>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :lg="24" :md="24" :sm="24" :xl="24">
        <reportTable :config="delieveredTable" v-loading="loading.delievered" :style="`height: ${reportHeight};`">
          <el-table-column
            prop="shopName"
            :label="$t('performance-analysis::receive::table_shopName')"
            min-width="130px"
            showOverflowTooltip
          ></el-table-column>
          <el-table-column
            prop="pay20ReceiveOrderNum"
            :label="$t('performance-analysis::receive::table_pay20order')"
            min-width="190px"
          ></el-table-column>
          <el-table-column
            prop="pay20ReceiveRate"
            :label="$t('performance-analysis::receive::table_pay20orderRate')"
            min-width="170px"
          >
            <template slot-scope="scope">
              <span>{{ scope.row['pay20ReceiveRate'] }}%</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="pay30ReceiveOrderNum"
            :label="$t('performance-analysis::receive::table_pay30order')"
            min-width="190px"
          ></el-table-column>
          <el-table-column
            prop="pay30ReceiveRate"
            :label="$t('performance-analysis::receive::table_pay30orderRate')"
            min-width="170px"
          >
            <template slot-scope="scope">
              <span>{{ scope.row['pay30ReceiveRate'] }}%</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="shipping20ReceiveOrderNum"
            :label="$t('performance-analysis::receive::table_send20order')"
            min-width="190px"
          ></el-table-column>
          <el-table-column
            prop="shipping20ReceiveRate"
            :label="$t('performance-analysis::receive::table_send20orderRate')"
            min-width="170px"
          >
            <template slot-scope="scope">
              <span>{{ scope.row['shipping20ReceiveRate'] }}%</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="shipping30ReceiveOrderNum"
            :label="$t('performance-analysis::receive::table_send30order')"
            min-width="190px"
          ></el-table-column>
          <el-table-column
            prop="shipping30ReceiveRate"
            :label="$t('performance-analysis::receive::table_send30orderRate')"
            min-width="170px"
          >
            <template slot-scope="scope">
              <span>{{ scope.row['shipping30ReceiveRate'] }}%</span>
            </template>
          </el-table-column>
        </reportTable>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import moment from 'moment'
import { getPerformanceCount, getDelieveredLineCharts, getShippingTable, getDelieveredTable } from '@/server/data'
import { getShopList } from '@/server/product'
import { pickerOptions } from '@/utils/datepickerConfig'
import setConfig from './setConfig'
import dataCard from '@/components/data-analysis/card'
import reportCard from '@/components/data-analysis/report'
import reportTable from '@/components/data-analysis/table'
import { reportJumpUrl } from '@/utils/config'

export default {
  name: 'performance-analysis',
  components: {
    dataCard,
    reportCard,
    reportTable
  },
  mixins: [setConfig],
  data() {
    return {
      pickerOptions: {
        ...pickerOptions,
        disabledDate: time => {
          return time.getTime() >= Date.parse(new Date())
        }
      },
      date: [moment().subtract(29, 'days'), moment()],
      params: {
        startDate: moment()
          .subtract(29, 'days')
          .format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
      },
      selectedShop: '',
      shopList: [{ shopName: this.$t('system::common::select_all'), shopId: '' }],
      cardOptions: [],
      reportHeight: '400px',
      delieveredLineCharts: {},
      shippingTable: [],
      delieveredTable: [],
      loading: {
        card: false,
        delieveredLineCharts: false,
        shipping: false,
        delievered: false
      }
    }
  },
  async mounted() {
    this.cardOptions = this.setCountList({})
    await this.getShopData()
    this.getAllData()
  },
  methods: {
    reportJumpUrl,
    async getShopData() {
      const { data } = await getShopList()
      if (data.code === this.$code && data.data) {
        this.shopList = [...this.shopList, ...data.data]
      }
    },
    getAllData() {
      this.getCount()
      this.getDelieveredLineCharts()
      this.getShippingTable()
      this.getDelieveredTable()
    },
    changeShop() {
      this.getAllData()
    },
    async getCount() {
      let obj = {
        ...this.params
      }
      if (this.selectedShop) obj = { shopId: Number(this.selectedShop), ...obj }
      this.loading.card = true
      const { data } = await getPerformanceCount(obj)
      this.cardOptions = this.setCountList(data.data.datas[0] || {}, this.params)
      this.loading.card = false
    },
    async getDelieveredLineCharts() {
      let obj = {
        ...this.params
      }
      if (this.selectedShop) obj = { shopId: Number(this.selectedShop), ...obj }
      this.loading.delieveredLineCharts = true
      const { data } = await getDelieveredLineCharts(obj)
      const list = Array.isArray(data.data.datas) ? data.data.datas : []
      this.delieveredLineCharts = this.setDelieveredLineChartsConfig(list)
      this.loading.delieveredLineCharts = false
    },
    async getShippingTable() {
      let obj = {
        ...this.params
      }
      if (this.selectedShop) obj = { shopId: Number(this.selectedShop), ...obj }
      this.loading.shipping = true
      const { data } = await getShippingTable(obj)
      const list = Array.isArray(data.data.datas) ? data.data.datas : []
      this.shippingTable = this.setShippingTableConfig(list)
      this.loading.shipping = false
    },
    async getDelieveredTable() {
      let obj = {
        ...this.params
      }
      if (this.selectedShop) obj = { shopId: Number(this.selectedShop), ...obj }
      this.loading.delievered = true
      const { data } = await getDelieveredTable(obj)
      const list = Array.isArray(data.data.datas) ? data.data.datas : []
      this.delieveredTable = this.setDelieveredTableConfig(list)
      this.loading.delievered = false
    },
    handlerDateChange(date) {
      this.params.startDate = moment(date[0]).format('YYYY-MM-DD')
      this.params.endDate = moment(date[1]).format('YYYY-MM-DD')
      this.getAllData()
    }
  }
}
</script>

<style lang="scss" scoped>
.card-content {
  margin-top: 10px;
}
.card-content__total {
  position: absolute;
  font-size: 16px;
  margin-top: 16px;
}
.date-label {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
